// =============================================================================
// src/lib/constants.ts
// Fixed values that do not change at runtime.
// =============================================================================

import { OrderStatus, ConnectionStatus } from './types';

export const STATUS_COLOURS: Record<string, string> = {
  Pending:   '#6b7280',
  Ordered:   '#3b82f6',
  Delivered: '#f59e0b',
  Closed:    '#22c55e',
};

// F-001 (L1/L2): every order follows ONE status cycle regardless of category.
// The old category-name branch (a separate "Consumable" cycle) has been removed.
export const STATUS_CYCLE: OrderStatus[] = ['Pending','Ordered','Delivered','Closed'];

// Maps each order status to its pill CSS class from the design system
export const STATUS_PILL_CLASS: Record<string, string> = {
  Pending:   'pill gray',
  Ordered:   'pill blue',
  Delivered: 'pill amber',
  Closed:    'pill green',
};

// Maps Supabase connection state to the header dot CSS class and label text
export const CONN_DOT_CLASS: Record<ConnectionStatus, string> = {
  connecting: 'hdot syncing',
  connected:  'hdot ok',
  slow:       'hdot syncing',
  offline:    'hdot err',
};

export const CONN_TEXT: Record<ConnectionStatus, string> = {
  connecting: 'Connecting…',
  connected:  'Live',
  slow:       'Slow connection',
  offline:    'Offline',
};
